import { TimeZoneEnum } from '@gohighlevel/ghl-proposals-common'
import { defineStore } from 'pinia'

interface ViewerAppStore {
  email: string
  userId: string
  apiKey: string
  tokenId: string
  companyId: string
  timeZone: TimeZoneEnum
  userName: string
  parentBaseUrl: string
  handshake: Promise<any>
  requestRetryCount: number
  currency: string
  isInternal: boolean
}

export const useAppStore = defineStore('appStore', {
  state: (): ViewerAppStore => ({
    email: '',
    userId: '',
    apiKey: '',
    tokenId: '',
    companyId: '',
    timeZone: '' as TimeZoneEnum,
    userName: '',
    parentBaseUrl: '',
    handshake: {} as Promise<any>,
    requestRetryCount: 0,
    currency: 'USD',
    isInternal: false,
  }),
  actions: {
    setupApp(params: Partial<ViewerAppStore> & { handshake: Promise<any> }) {
      this.email = params.email || ''
      this.userId = params.userId || ''
      this.apiKey = params.apiKey || ''
      this.tokenId = params.tokenId || ''
      this.companyId = params.companyId || ''
      this.timeZone = params.timeZone || ('' as TimeZoneEnum)
      this.userName = params.userName || ''
      this.parentBaseUrl = params.parentBaseUrl || ''
      this.handshake = params.handshake
      this.currency = params.currency || 'USD'

      this.isInternal = [
        '5DP4iH6HLkQsiKESj6rh',
        'YuTUZlUtrwBtvmgByZDW',
        'ktapXmiRvMM4pJHyN3b3',
        'pfpm9iFi4k5yvjnstXWU',
      ].includes(this.companyId)
    },
    refreshToken(token: string) {
      this.tokenId = token
      console.info('refreshToken')
    },
    updateRequestRetryCount(count: number) {
      this.requestRetryCount = count
    },
  },
})
